"use strict";
exports.__esModule = true;
exports.data = void 0;
exports.data = [
    {
        uuid: 'uuid1',
        name: 'Instance #1',
        dateAdded: new Date('2021-01-10T13:45:00Z')
    },
    {
        uuid: 'uuid2',
        name: 'Instance #2',
        dateAdded: new Date('2021-02-01T10:45:00Z')
    }
];
